import React from 'react'
export default function InnerPageMore() {
  return (
    <div>
      <header>
        <h1>Other Pages</h1>
        <p>
            Here are some other sections of my website that you might find interesting.
        </p>
      </header>
      <dl>
        <dt><a
          href="/blog"
        >Blog</a></dt>
        <dd>
              My blog,
              Sealed Tuna Sandwich, where I write about software development, music, and other topics.
        </dd>
        <dt><a href="/talks">Talks</a></dt>
        <dd>
            Presentations I've given at conferences and other events.
        </dd>
        <dt><a href="/publications">Publications</a></dt>
        <dd>
            Publications from my previous career in music and auditory research, as well as my
            grad school thesis and dissertation.
        </dd>
        <dt><a href="/tech">Tech</a></dt>
        <dd>
            Information about languages, frameworks and environments that I specialize in.
        </dd>
      </dl>

    </div>
  )
}
